import _ from 'lodash'
import { useEffect } from 'react'
import styled from 'styled-components'

import { INavParams } from 'pared/Routes/navParams'
import { feature, page } from 'pared/analytics/user'
import useLocationInfo from 'pared/components/LocationInfo/hooks/useLocationInfo'
import LocationInfo from 'pared/components/LocationInfo/index'
import DateRangeSelector from 'pared/components/nav/DateRangeSelector'
import LocationSelector from 'pared/components/nav/LocationSelector'
import COLORS from 'pared/constants/colors'
import { MOBILE_WIDTH } from 'pared/constants/styles'
import { getBrandSettings } from 'pared/customer'
import useGetDateRange from 'pared/hooks/useGetDateRange'
import { scrollToTop } from 'pared/utils/web'

import PurchasesTable from './PurchasesTable'

interface IProps {
  navParams: INavParams
}

const Purchases = ({ navParams }: IProps) => {
  const brandSettings = getBrandSettings()
  const storeId = navParams.storeId
  const storeIdNum = parseInt(storeId || '0') || 0
  const locationInfo = useLocationInfo(storeIdNum)

  const dateRange = useGetDateRange()
  const locationId = locationInfo?.id
  const locationName = locationInfo?.name

  useEffect(() => {
    if (navParams.pageUrl) {
      scrollToTop()
      page.visit(navParams.pageUrl)
      feature.used('Purchases')
    }
  }, [navParams.pageUrl])

  const storeTitle = `
    ${brandSettings.labels.business.store}:
    ${locationInfo?.displayName}
  `

  return (
    <>
      <Header>
        <div>
          {locationId ? (
            <h1>{storeTitle}</h1>
          ) : (
            <PageStatusDiv>Loading ...</PageStatusDiv>
          )}
          {locationId ? <LocationInfo locationId={locationId} /> : null}
        </div>
        <Selectors>
          <LocationSelector navParams={navParams} />
          <DateRangeSelector navParams={navParams} />
        </Selectors>
      </Header>
      {locationId && locationName && dateRange ? (
        <PurchasesTable
          locationId={locationId}
          locationName={locationName}
          startDate={dateRange.startDateStr}
          endDate={dateRange.endDateStr}
        />
      ) : null}
    </>
  )
}

export default Purchases

const Header = styled.div`
  display: flex;
  width: 1200px;
  justify-content: space-between;

  @media ${MOBILE_WIDTH} {
    margin: 0px;
    flex-direction: column-reverse;
    width: 100%;
  }

  h1 {
    margin: 0px;
    font-family: Lexend-SemiBold;
    font-size: 24px;
    font-style: normal;
    font-weight: 700;
    color: ${COLORS.Chalkboard};
    line-height: 52px;

    @media ${MOBILE_WIDTH} {
      padding: 30px 0px 0px;
    }
  }

  & > div:first-child {
    @media ${MOBILE_WIDTH} {
      padding: 0px 25px;
    }
  }
`

const Selectors = styled.div`
  @media ${MOBILE_WIDTH} {
    padding: 10px 25px;
    background-color: rgb(196, 196, 196);
  }

  & > * {
    &:not(:last-child) {
      margin-right: 7px;

      @media ${MOBILE_WIDTH} {
        margin-right: 0px;
      }
    }

    @media ${MOBILE_WIDTH} {
      width: 100% !important;
    }
  }
`

const PageStatusDiv = styled.div`
  font-family: Lexend-Regular;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  color: ${COLORS.Steel};

  @media ${MOBILE_WIDTH} {
    padding: 10px;
  }
`

const VerticalSpacer30px = styled.div`
  height: 30px;
`
